import React, { useState } from "react";
import "../styles/style.css";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { ArmadaFormsProvider } from "../context/form-context";
import { useStaticQuery, graphql, StaticQuery } from "gatsby";
import { SettingsAndSlugs } from "../models/settings-and-page-slugs.model";
import Helmet from "react-helmet";
import classNames from "classnames";
import PreviewBanner from "./PreviewBanner";

const Layout: React.FC = ({ children }) => {
  // client test = https://drafbox-backend-dev.herokuapp.com/api/project/5ea1575f8c9344001f9a89ff/forms

  const [isMenuToggled, setIsMenuToggled] = useState(false);

  const data = useStaticQuery<SettingsAndSlugs | any>(graphql`
    query {
      draftboxSettings {
        identity {
          language
        }
        design {
          colors {
            key
            value
          }
          fonts {
            key
            value
            weights {
              key
              value
            }
          }
        }
      }
    }
  `);

  const googleFonts = data.draftboxSettings.design.fonts.filter(
    (font) => font.value !== "system-ui"
  );

  const fontWeights = data.draftboxSettings.design.fonts
    .map((f) => f.weights)
    .flat();

  return (
    <ArmadaFormsProvider client={process.env.GATSBY_FORM_URL}>
      <Helmet
        htmlAttributes={{
          lang: data.draftboxSettings.identity.language
            ? data.draftboxSettings.identity.language
            : "auto",
        }}
      >
        {process.env.NODE_ENV === "development" && (
          <style>{`:root {
                  ${data.draftboxSettings.design.colors.reduce(
                    (acc, dec, index, src) => {
                      return (
                        acc +
                        dec.key +
                        " : " +
                        dec.value +
                        ";" +
                        (src.length - 1 === index ? "" : "\n")
                      );
                    },
                    ""
                  )}
                  ${data.draftboxSettings.design.fonts.reduce(
                    (acc, dec, index, src) => {
                      return (
                        acc +
                        dec.key +
                        " : " +
                        dec.value +
                        ";" +
                        (src.length - 1 === index ? "" : "\n")
                      );
                    },
                    ""
                  )}
                  ${fontWeights.reduce((acc, dec, index, src) => {
                    return (
                      acc +
                      dec.key +
                      " : " +
                      dec.value +
                      ";" +
                      (src.length - 1 === index ? "" : "\n")
                    );
                  }, "")}
              }`}</style>
        )}
        {process.env.NODE_ENV === "development" && (
          <link rel="preconnect" href="https://fonts.gstatic.com" />
        )}
        {process.env.NODE_ENV === "development" && (
          <link
            href={`https://fonts.googleapis.com/css2?${googleFonts.reduce(
              (acc, dec, i, src) => {
                if (i === 0) {
                  return (
                    acc +
                    "family=" +
                    dec.value.replace(" ", "+") +
                    ":wght@" +
                    [...new Set(dec.weights.map((v) => v.value))]
                      .map((w, i, src) =>
                        i !== src.length - 1 ? w + ";" : w + ""
                      )
                      .join("")
                  );
                } else {
                  return (
                    acc +
                    "&" +
                    "family=" +
                    dec.value.replace(" ", "+") +
                    ":wght@" +
                    [...new Set(dec.weights.map((v) => v.value))]
                      .map((w, i, src) =>
                        i !== src.length - 1 ? w + ";" : w + ""
                      )
                      .join("")
                  );
                }
              },
              ""
            )}&display=swap`}
            rel="stylesheet"
          ></link>
        )}
        <link rel="preconnect" href="https://ka-f.fontawesome.com" />
        <link rel="preconnect" href="https://storage.googleapis.com" />
        <script
          src="https://kit.fontawesome.com/9bc68fd9eb.js"
          defer={true}
          crossOrigin="anonymous"
        ></script>
      </Helmet>
      <div
        className={classNames("flex flex-col min-h-screen", {
          "h-screen overflow-hidden": isMenuToggled,
          "h-auto": !isMenuToggled,
        })}
      >
        {process.env.NODE_ENV === "development" && process.env.GATSBY_DRAFTBOX_PREVIEW === "true" && (
         <PreviewBanner/>
        )}
        <div
          className={classNames({ "h-screen overflow-auto": isMenuToggled })}
        >
          <Navbar
            isMenuToggled={isMenuToggled}
            toggleMenu={() => setIsMenuToggled(!isMenuToggled)}
          />
          <hr />
        </div>
        <div className="flex-grow">{children}</div>
        <Footer />
      </div>
    </ArmadaFormsProvider>
  );
};

export default Layout;
